module.exports = __webpack_public_path__ + "media/images/lb/272-8f2ad37911a7f1784ac564113eadc555.svg";